import { httpGet, httpPost } from "@eres/rest";
import { TabuMobileConfig } from "@10x/tabu-mobile-api";
import { ArabicChars, EnglishChars, filterCharSet, SpaceChars } from "@my-dld/components/TextFilters/RegExFilter";
import { ReqTabuDoc } from "@my-dld/screens/TabuRequest/BaseTabuRequestForm";
import { LocaleUtil, ServerDate } from "@eres/core";
import { DocumentModel } from "@10x/tabu-mobile-api/dist/registartion/entities";
import { ValidationError } from "@eres/rtregistrationapi/entities";
import cfg from "../../src/addproperty/api/config";
export enum TabuLookUp {
	GENDER = "gender",
	COUNTRIES = "countries",
	LANGUAGES = "languages",
	RESIDENT_PERSON_DOCUMENTS = "residentpersondocuments",
	NATIONAL_PERSON_DOCUMENTS = "nationalpersondocuments",
	EMIRATES = "emirates",
}

const TabuLookUpStateKeys = {
	[ TabuLookUp.GENDER ]: "Gender",
	[ TabuLookUp.COUNTRIES ]: "Countries",
	[ TabuLookUp.LANGUAGES ]: "Languages",
	[ TabuLookUp.RESIDENT_PERSON_DOCUMENTS ]: "ResidentPersonDocuments",
	[ TabuLookUp.NATIONAL_PERSON_DOCUMENTS ]: "NationalPersonDocuments",
	[ TabuLookUp.EMIRATES ]: "Emirates",
};

export function tabuLookUpToStateKey( lookup: TabuLookUp ): string {
	if ( TabuLookUpStateKeys[ lookup ] ) {
		return TabuLookUpStateKeys[ lookup ];
	}
	return lookup as string;
}

export interface RegisterTabuLookup {
	Id: number;
	NameAr: string;
	NameEn: string;
}

export interface TabuLangLookup {
	Id: string;
	NameAr: string;
	NameEn: string;
}

export interface TabuCountryLookup {
	id: number;
	NameAr: string;
	NameEn: string;
	CountryCode: string;
	NationalityAr: string;
	NationalityEn: string;
	Identity: number;
}

export interface DNRDModel {
	Email?: string;
	NameEn?: string;
	NameAr?: string;
	GenderId?: number;
	EmiratesId?: string;
	EIDExpiryDate?: string;
	IsGCCNational?: boolean;
	Mobile?: string;
	BirthDate?: string;
	Documents?: ReqTabuDoc[];
	NationalityEntity?: TabuCountryLookup;
	Passport?: string;
	PassportExpiryDate?: ServerDate;
	CountryId?: number;
	BirthPlaceNameAr?: string;
	BirthPlaceNameEn?: string;
	LanguageID?: number;
	Gender?: RegisterTabuLookup;
	Language?: RegisterTabuLookup;
	NationalDocuments?: ReqTabuDoc[];
	ResidenceDocuments?: ReqTabuDoc[];
}

export interface OwnerRegiModel {
	BirthDate?: ServerDate;
	EmiratesID?: string;
	DomesticContact?: DomesticContactModel;
	EmiratesIDExpiry?: ServerDate;
	PersonType?: number;
	Nationality?: NationalityModel;
	BirthPlace?: BirthPlaceModel;
	Gender?: GenderModel;
	Documents?: DocumentModel[];
	PreferedContactLanguage?: string;
	PersonName?: PersonNameModel;
	PassportInformation: PassportInformation;
}

export interface PassportInformation {
	IssueAuthority: NationalityModel;
	PassportType: NationalityModel;
	Number: string;
	IssuePlace?: string;
	StartDate: ServerDate;
	EndDate: ServerDate;
}

export interface NationalityModel {
	Identity?: number;
	NameAr?: string;
	NameEn?: string;
}

export interface BirthPlaceModel {
	Identity?: number;
	ArabicName?: string;
	EnglishName?: string;
}

export interface GenderModel {
	Identity?: number;
	NameAr?: string;
	NameEn?: string;
}

export interface DomesticContactModel {
	Identity?: number;
	Email?: string;
	MobileNumber?: MobileNumberModel;
}

export interface MobileNumberModel {
	Identity?: number;
	CountryCode?: string;
	MobileCode?: string;
	MobileNumber?: string;
}

export interface PersonNameModel {
	Identity?: number;
	EnglishName?: string;
	ArabicName?: string;
}


export interface Reasons {
	NameAr:               null;
	NameEn:               string;
	PropertyId:           number;
	BlockDate:            string;
	BlockReason:          string;
	BlockLetterNumber:    null;
	BlockLetterDate:      null;
	ProcedureCount:       number;
	DBAction:             number;
	Identity:             number;
	ValidationErrorsList: null;
}

export interface ValidationErrorsListContainer {
	ValidationErrorsList: ValidationError[] | null;
}
interface BlockReasonResponse extends ValidationErrorsListContainer {
	Data: Reasons[];
	MessageEn: string;
	MessageAr: string;
	Status: number;
}

function TrimMultiSpaces( input: string ): string {
	if ( input ) {
		return input.replace( /\s+/, " " ).trim();
	}
	return input;
}

export function normaliseDNRDModal( data: DNRDModel ) {
	if ( data ) {
		data.NameEn = TrimMultiSpaces( filterCharSet( data.NameEn + "", true, EnglishChars, SpaceChars ) );
		data.NameAr = TrimMultiSpaces( filterCharSet( data.NameAr + "", true, ArabicChars, SpaceChars ) );
		data.BirthPlaceNameAr = TrimMultiSpaces( filterCharSet( data.BirthPlaceNameAr + "", true, ArabicChars, SpaceChars ) );
		data.BirthPlaceNameEn = TrimMultiSpaces( filterCharSet( data.BirthPlaceNameEn + "", true, ArabicChars, SpaceChars ) );
		data.IsGCCNational = data?.NationalityEntity?.Identity === 1 ?? false;
	}
	return data;
}

export function validateEmiratesID( eid: string ) {
	return httpGet( TabuMobileConfig.tabuAPI().endPoint() + "Users/ValidateEmiratesId?eId=" + eid + "&version=IOS" );
}

export function getDataFromDNRD( eid?: string ) {
	return httpGet( TabuMobileConfig.tabuAPI().endPoint() + "Tabu/ValidatePersonFromDNRD?documentNumber=" + eid );
}

export function loadTabuLookUp( lookup: TabuLookUp ) {
	return httpGet( TabuMobileConfig.tabuAPI().endPoint() + "lookup/GetLookup?name=" + lookup );
}

export function populateTabuLookUp( lookup: TabuLookUp, stateHolder?: any, callback?: ( values?: any[] ) => void ) {
	loadTabuLookUp( lookup ).then( lkpData => {
		const stateKey = tabuLookUpToStateKey( lookup );
		if ( stateHolder ) {
			stateHolder.setState( {
				[ stateKey ]: lkpData.Response,
			} );
		}
		if ( callback ) {
			callback( lkpData.Response );
		}
	} ).catch( reason => {
			if ( callback ) {
				callback( undefined );
			}
		},
	);
}

export function sendOTPToRegMobile( mobile: string ) {
	return httpGet( TabuMobileConfig.tabuAPI().endPoint() + "Tabu/ValidateNewPersonMobile?mobile=" + mobile );
}

export function registerPerson( request: OwnerRegiModel ) {
	return httpPost( TabuMobileConfig.tabuAPI().endPoint() + "tabu/CreatePerson", request );
}

export function verifyRegMobileOTP( mobile: string, token: string ) {
	return httpGet( TabuMobileConfig.tabuAPI().endPoint() + "Users/GetVerifyToken?token=" + token + "&mobile=" + mobile );
}

export function checkBlockListOnProperty(propertyId: string): Promise<BlockReasonResponse> {
	return httpGet(cfg.blockApi().endPoint() + "PropertyBlocking/GetPropertyBlockingList?propertyId=" + propertyId);
}

export function checkTabuRegError( apiResponse: any,
                                   onNoError: ( response: any ) => void,
                                   onValidationError: ( errors: object[], errorMessage: string ) => void ) {
	if ( apiResponse == undefined ) {
		onValidationError( [], "Null response" );
	} else if ( apiResponse.Response == undefined ) {
		let message = "";
		if ( apiResponse.Code != undefined ) message = message + apiResponse.Code;
		if ( apiResponse.Message != undefined ) message = message + ":" + apiResponse.Message;
		onValidationError( apiResponse, message.trim() );
	} else if ( Array.isArray( apiResponse.Response ) && apiResponse.Response.length > 0 ) {
		let errors = apiResponse.Response;
		let message = "";
		for ( let error of errors ) {
			let msg = LocaleUtil.getLocalValue( {
				ar: error.ErrorMessageAr,
				en: error.ErrorMessage,
			} );
			if ( msg != undefined ) {
				message += "\n" + msg;
			} else {
				message += "\n" + error.ErrorNumber + ":" + error.ValidationType;
			}
		}
		onValidationError( apiResponse, message.trim() );
	} else if ( apiResponse.Response != undefined ) {
		let rsp = apiResponse.Response;
		onNoError( rsp );
	}
}
